/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const OrderContentType = {
    MEDICAL_EXAMINATION: 'MEDICAL_EXAMINATION',
    COURSE: 'COURSE'
} as const;
export type OrderContentType = typeof OrderContentType[keyof typeof OrderContentType];

